'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    HorizonIcon: ()=>HorizonIcon
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const horizon_icons_namespaceObject = require("@pcln/horizon-icons");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const CdnIcon_variants_cjs_namespaceObject = require("../CdnIcon/CdnIcon.variants.cjs");
const lazyIconCache = new Map();
function getLazyIcon(name) {
    if (!lazyIconCache.has(name)) {
        const LazyIcon = /*#__PURE__*/ (0, external_react_namespaceObject.lazy)(()=>{
            const icon = horizon_icons_namespaceObject.iconRegistry[name];
            if (!icon) throw new Error(`@pcln/horizon-icons//HorizonIcon: Icon ${name} not found`);
            return icon?.() ?? null;
        });
        lazyIconCache.set(name, LazyIcon);
    }
    return lazyIconCache.get(name);
}
const HorizonIcon = /*#__PURE__*/ (0, external_react_namespaceObject.memo)(({ name, className, palette, shade, size, ...svgProps })=>{
    if (!name) return null;
    const IconComponent = getLazyIcon(name);
    const classes = (0, index_cjs_namespaceObject.cn)((0, CdnIcon_variants_cjs_namespaceObject.cdnIconVariants)({
        palette,
        shade,
        size
    }), className);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: classes,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_namespaceObject.Suspense, {
            fallback: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: "bg-neutral-8"
            }),
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(IconComponent, {
                ...svgProps
            })
        })
    });
});
exports.HorizonIcon = __webpack_exports__.HorizonIcon;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "HorizonIcon"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
